module.exports = __webpack_public_path__ + "img/black-truffle.bd88d129.jpg";